var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnveloppe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.652,
    height: 28.636,
    viewBox: "0 0 41.652 28.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_6_",
    "data-name": "email (6)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10153",
    "data-name": "Path 10153",
    d: "M339.392,154.148l14.042,8.877V144.9Z",
    transform: "translate(-311.782 -139.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10154",
    "data-name": "Path 10154",
    d: "M0,144.9v18.129l14.042-8.877Z",
    transform: "translate(0 -139.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10155",
    "data-name": "Path 10155",
    d: "M39.931,80H3.485A2.571,2.571,0,0,0,.96,82.215l20.748,13.67,20.748-13.67A2.571,2.571,0,0,0,39.931,80Z",
    transform: "translate(-0.882 -80)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10156",
    "data-name": "Path 10156",
    d: "M26.166,277.923l-3.684,2.426a1.307,1.307,0,0,1-1.432,0l-3.684-2.429L1.024,288.258a2.567,2.567,0,0,0,2.52,2.2H39.989a2.567,2.567,0,0,0,2.52-2.2Z",
    transform: "translate(-0.94 -261.819)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnveloppe);
export default __webpack_public_path__ + "static/media/enveloppe.4dc93d36.svg";
export { ForwardRef as ReactComponent };